module.exports = __webpack_public_path__ + "img/logo-preto-amorsaude copy.99657fa9.svg";